import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AccordionModule,
  ButtonModule,
  DialogModule,
  DropdownModule,
  FlexboxModule,
  FlyoutMenuModule,
  GridModule,
  HeaderDocumentListModule,
  IconModule,
  LinkItemModule,
  PaddingModule,
  RatingModule,
  SimpleModalModule,
  SpacingModule,
  SummaryItemModule,
  TitleModule,
  TooltipModule,
} from '@frk/eds-components';
import { FundSummaryService } from '@products/services/fund-summary.service';
import { TranslateModule } from '@shared/translate/translate.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FundHeaderAlertsComponent } from './fund-header-alerts/fund-header-alerts.component';
import { FundHeaderEntryComponent } from './fund-header-entry/fund-header-entry.component';
import { FundTitleComponent } from './fund-title/fund-title.component';
import { HeaderDocumentsComponent } from './header-documents/header-documents.component';
import { FundTitleService } from './services/fund-title.service';
import { MorningStarDetailsModule } from './summary/morning-star-details/morning-star-details.module';
import { SummaryInternationalComponent } from './summary/summary-international/summary-international.component';
import { SummaryUSComponent } from './summary/summary-us/summary-us.component';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
  declarations: [
    FundHeaderEntryComponent,
    FundTitleComponent,
    FundHeaderAlertsComponent,
    SummaryComponent,
    SummaryInternationalComponent,
    SummaryUSComponent,
    HeaderDocumentsComponent,
  ],
  imports: [
    AccordionModule,
    ButtonModule,
    CommonModule,
    DialogModule,
    DropdownModule,
    FlyoutMenuModule,
    GridModule,
    HeaderDocumentListModule,
    IconModule,
    LinkItemModule,
    MorningStarDetailsModule,
    NgxSkeletonLoaderModule,
    RatingModule,
    SimpleModalModule,
    SpacingModule,
    SummaryItemModule,
    TooltipModule,
    TitleModule,
    TranslateModule,
    FlexboxModule,
    PaddingModule,
  ],
  entryComponents: [
    FundHeaderEntryComponent,
    FundTitleComponent,
    SummaryComponent,
  ],
  providers: [FundSummaryService, FundTitleService],
})
export class FundHeaderModule {}

export const fundHeaderModuleComponentMapping = {
  'Fund Header': FundHeaderEntryComponent,
};
